// src/theme/muiTheme.js
import { createTheme } from "@mui/material";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#3F51B5", // Indigo
    },
    secondary: {
      main: "#FF9800", // Orange
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 500,
    },
    body1: {
      fontSize: 14,
    },
  },
  spacing: 8, // Global spacing unit
});

export default muiTheme;
